/**
 * 需求来源：docs/合作页、CJ Entity、Ads开户落地页3个/AI提示词.md（第2次提交 任务1）。
 * 工单弹窗（React 复刻 public/egg/script/vue/workorder.vue，questionCode 固定 CJ003）。
 * 逻辑等价：
 *  - 打开由父组件控制（open）；父组件在 openTicket() 中已做未登录跳 /login.html?target=<base64(url?show=ticket)> 的处理。
 *  - open 变 true 时拉取 questionFormList：CJ_.$axios.post('messageCenterWeb/issueType/question/getQuestionFormByCode',{code:'CJ003'})。
 *  - 提交：CJ_.$axios.post('messageCenterWeb/issue/createIssue',{issueTypeId,questionTypeId,questionFormList,questionDesc})，
 *    成功后跳 /partnership-success.html?from=workorder。
 * 全局 CJ_ 仅客户端存在：所有调用置于事件回调 / useEffect 内，并做 typeof window!=='undefined' 与 window.CJ_ 防御。
 * 注意事项：可见文案由父组件通过 textConfig（constants.WORKORDER，i18next 取词）注入；DEFAULT_TEXT 仅作字段兜底。
 */
import React, { useState, useEffect, useCallback } from 'react';

var DEFAULT_TEXT = {
  suggestion: 'You may submit a request for advertising, after which our exclusive advertising consultant will contact you.',
  messageLabel: 'Message',
  messagePlaceholder: 'Please enter such information as product weight and destination country so that we can solve your doubts and offer you personalized shipping solutions as soon as possible.',
  messageTip: 'Please enter message',
  fieldTipPrefix: 'Please enter',
  submit: 'Submit',
  linkTip: 'You can check it in the',
  linkText: 'Ticket List.',
  failMessage: 'Ticket has been suspended for update. Please contact your agent directly for any doubts.',
};

function getAxios() {
  if (typeof window === 'undefined') return null;
  return (window.CJ_ && window.CJ_.$axios) ? window.CJ_.$axios : null;
}

function WorkOrder(props) {
  var open = props.open;
  var onClose = props.onClose;
  var textConfig = Object.assign({}, DEFAULT_TEXT, props.textConfig || {});

  var _msg = useState('');
  var message = _msg[0];
  var setMessage = _msg[1];
  var _tip = useState(false);
  var showTip = _tip[0];
  var setShowTip = _tip[1];
  var _q = useState({});
  var question = _q[0];
  var setQuestion = _q[1];
  var _list = useState([]);
  var questionFormList = _list[0];
  var setQuestionFormList = _list[1];

  var getQuestion = useCallback(function () {
    var axios = getAxios();
    if (!axios) return;
    axios.post('messageCenterWeb/issueType/question/getQuestionFormByCode', { code: 'CJ003' })
      .then(function (res) {
        var body = Array.isArray(res) ? res[1] : res;
        if (body && +body.success) {
          var data = body.data || {};
          setQuestion(data);
          var list = data.questionFormList || [];
          if (list.length > 0) {
            setQuestionFormList(list.map(function (item) {
              return Object.assign({}, item, { input: '', showTip: false });
            }));
          } else {
            setQuestionFormList([]);
          }
        }
      })
      .catch(function () { /* 静默失败，仍可提交 message */ });
  }, []);

  useEffect(function () {
    if (open) {
      setMessage('');
      setShowTip(false);
      getQuestion();
    }
  }, [open, getQuestion]);

  function onFieldInput(index, value) {
    setQuestionFormList(function (prev) {
      return prev.map(function (it, i) {
        if (i !== index) return it;
        return Object.assign({}, it, { input: value, showTip: value.length > 0 ? false : it.showTip });
      });
    });
  }

  function onMessageInput(value) {
    setMessage(value);
    if (value.length > 0) setShowTip(false);
  }

  function submit() {
    var isValid = true;
    var fromList = [];
    if (questionFormList.length > 0) {
      var nextList = questionFormList.map(function (item) {
        var invalid = !item.input && item.required;
        if (invalid) isValid = false;
        return Object.assign({}, item, invalid ? { showTip: true } : {});
      });
      setQuestionFormList(nextList);
      fromList = questionFormList.map(function (item) {
        return { paramCnName: item.paramCnName, paramEnName: item.paramEnName, input: item.input };
      });
      if (!isValid) return;
    }
    if (!message) { setShowTip(true); return; }

    var axios = getAxios();
    if (!axios) return;
    axios.post('messageCenterWeb/issue/createIssue', {
      issueTypeId: question.issueTypeId,
      questionTypeId: question.questionTypeId,
      questionFormList: fromList,
      questionDesc: message,
    }).then(function (res) {
      var body = Array.isArray(res) ? res[1] : res;
      if (body && +body.success) {
        // 260714 第14次补充(需求㉑)：提交成功后先关闭工单弹窗，再跳转成功页（跳走同时关闭弹窗）。
        setMessage('');
        if (typeof onClose === 'function') onClose();
        if (typeof window !== 'undefined') {
          window.location.href = '/partnership-success.html?from=workorder';
        }
      } else if (window.CJ_ && window.CJ_.$my_message && window.CJ_.$my_message.info) {
        window.CJ_.$my_message.info(textConfig.failMessage);
      }
    }).catch(function () { /* ignore */ });
  }

  if (!open) return null;

  return (
    <div className="cj-ads-workorder">
      <div className="cj-ads-workorder-mask" onClick={onClose} />
      <div className="cj-ads-workorder-dialog" role="dialog" aria-modal="true">
        <span className="cj-ads-workorder-close" onClick={onClose} role="button" aria-label="Close">×</span>
        <p className="cj-ads-workorder-suggestion">{textConfig.suggestion}</p>

        <div className="cj-ads-workorder-content">
          {questionFormList.map(function (item, index) {
            return (
              <div className="cj-ads-workorder-item" key={item.paramEnName || index}>
                <p className="cj-ads-workorder-title">
                  {item.required ? <span className="must">*</span> : null} {item.paramEnName}
                </p>
                <div className="cj-ads-workorder-field">
                  <textarea
                    maxLength={300}
                    value={item.input}
                    placeholder=""
                    onChange={function (e) { onFieldInput(index, e.target.value); }}
                  />
                  <span className="cj-ads-workorder-count">{(item.input || '').length}/300</span>
                  {item.showTip ? (
                    <p className="cj-ads-workorder-tip">
                      {textConfig.fieldTipPrefix} {item.paramEnName && item.paramEnName.toLowerCase()}
                    </p>
                  ) : null}
                </div>
              </div>
            );
          })}

          <p className="cj-ads-workorder-title"><span className="must">*</span> {textConfig.messageLabel}</p>
          <div className="cj-ads-workorder-field">
            <textarea
              maxLength={5000}
              value={message}
              placeholder={textConfig.messagePlaceholder}
              onChange={function (e) { onMessageInput(e.target.value); }}
            />
            <span className="cj-ads-workorder-count">{message.length}/5000</span>
            {showTip ? <p className="cj-ads-workorder-tip">{textConfig.messageTip}</p> : null}
          </div>
        </div>

        <button className="cj-ads-workorder-submit" type="button" onClick={submit}>{textConfig.submit}</button>
        <p className="cj-ads-workorder-linktip">
          {textConfig.linkTip} <a href="/mine/ticket" target="_blank" rel="noopener noreferrer">{textConfig.linkText}</a>
        </p>
      </div>
    </div>
  );
}

export default WorkOrder;
